module.exports = __webpack_public_path__ + "static/media/avril-lavigne-win.44648b54.jpg";